import { DEFAULT_PLAN_YEAR, SUPPORTED_PLAN_YEARS } from 'db/planYears';

export { DEFAULT_PLAN_YEAR, SUPPORTED_PLAN_YEARS };

/** Current coverage year used for {{planYear}} copy. */
export const PLAN_YEAR = 2026;

/** Upcoming Medicare plan year for {{nextPlanYear}} copy. */
export const NEXT_PLAN_YEAR = 2027;

/** Plan year to open on for the /wcy answer: "this" year, otherwise the default. */
export function planYearForShoppingPreference(
  preferredShoppingYear: string | undefined
): number {
  return preferredShoppingYear === 'this' ? PLAN_YEAR : DEFAULT_PLAN_YEAR;
}

export function normalizePlanYear(year: number): number {
  if (!Number.isInteger(year) || year < 2000 || year > 2100) {
    throw new Error(`Invalid plan year: ${year}`);
  }
  return year;
}
